module.exports = __webpack_public_path__ + "99ea5d4bef7daee3f154de709c0971d1.svg";